import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppFeatures, Path, PermissionSubject } from '@s8l/client-tree-lib';
import { Subscription, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';

import { CmsService } from 'src/app/services/cms.service';
import { Role } from 'src/app/services/jsonrpc/user-server.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy {
  public root: any = {};
  public selected: string[] = [];
  public roles: Role[];

  public readonly chatSubject = PermissionSubject.Node.withSub('chat');

  private subscription: Subscription = null;

  constructor(private cms: CmsService, private users: UserService, private router: Router) {}

  public ngOnInit() {
    if (!this.cms.appFeatures.includes(AppFeatures.Chat)) {
      this.router.navigate(['/'], { replaceUrl: true });
    }

    this.subscription = combineLatest([this.cms.tree.pipe(filter(root => root != null)), this.users.roles]).subscribe(data => {
      this.root = data[0].root;
      this.roles = data[1];
      if (this.selected.length == 0 && this.roles.length > 0) {
        this.selected.push(this.roles[0].name);
      }
    });
  }

  public ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
